export default __webpack_public_path__ + "icon_handling.da56f461178142985500339e6db6753f.svg";